/**
 * Inline stroke icons for the six-destination nav (IA slice 1,
 * docs/product/ui-information-architecture.md §3) — copied from the
 * founder-approved mockups (design-ia/Main.dc.html, NavRoles.dc.html) as
 * React components rather than `dangerouslySetInnerHTML`, so they're real
 * JSX: no injected-markup surface, and they inherit `currentColor` the same
 * way the rest of the nav's active/hover states already work (shell.css's
 * `.nav-sidebar__link.is-active { color: var(--color-accent) }` colors the
 * icon along with the label for free).
 *
 * Every icon is 18x18, `aria-hidden` (the link text is the accessible name;
 * see NavSidebar.tsx), `focusable="false"` (matches every other inline SVG
 * in this app — Firefox otherwise tab-stops into a purely decorative icon).
 */
import type { SVGProps } from "react";

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    />
  );
}

export function HomeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
    </Icon>
  );
}

export function DevelopIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="m8 6-5 6 5 6" />
      <path d="m16 6 5 6-5 6" />
    </Icon>
  );
}

export function OperateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M3 12h4l3-7 4 14 3-7h4" />
    </Icon>
  );
}

export function FleetIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="3" y="4" width="18" height="7" rx="1.5" />
      <rect x="3" y="13" width="18" height="7" rx="1.5" />
      <circle cx="7" cy="7.5" r="0.5" fill="currentColor" />
      <circle cx="7" cy="16.5" r="0.5" fill="currentColor" />
    </Icon>
  );
}

export function GovernIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6Z" />
      <path d="m9 12 2 2 4-4" />
    </Icon>
  );
}

export function SettingsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1 7 17M17 7l2.1-2.1" />
    </Icon>
  );
}
